import { BaseAPI } from "./base.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { Municipios } from "@/models/municipios";
import { map } from "rxjs";

export class MunicipiosApi extends BaseAPI<Municipios> {
    constructor(){
        super()
        this.apiUrl += '/municipio'
    }
    /**
     * show
     */
    public find(nome: string): AxiosObservable<Municipios>{
        return this.axios.get(`${this.apiUrl}/${nome}`, {
        })
        .pipe(map((data: any) => {
            return data;
        }))
        
    }
}
